import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { usuarioService } from "../../../services/usuarioService";

export const useUsuario = (isModalOpen: boolean, usuarioId: number) => {
  const [usuario, setUsuario] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as assinaturas
  useEffect(() => {
    const fetchUsuario = async () => {
      if (isModalOpen && usuarioId) {
        try {
          const data = await usuarioService(usuarioId);
          if (data) {
            setUsuario(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar usuários: ", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchUsuario();
  }, [isModalOpen, usuarioId]);

  return { usuario, isLoading };
};
